import { Layout, Spin } from "antd";
import { useWatchGlobalCurrency } from "features/language-switcher";
import { usePushSync } from "features/push-notifications";
import { ReactNode, useEffect } from "react";
import { NavBar } from "widgets/navigation";
import { THRESHOLD } from "./constants";
import { usePullToRefresh } from "./hooks/use-pull-to-refresh";
import { useRouteQueryKeys } from "./hooks/use-route-query-keys";
import styles from "./index.module.scss";

export const MainLayout = ({
  children,
  withoutToolbar,
}: {
  children: ReactNode;
  withoutToolbar?: boolean;
}) => {
  useWatchGlobalCurrency();
  usePushSync();
  const queryKeys = useRouteQueryKeys();
  const { pullDistance, isRefreshing, isReady } = usePullToRefresh(queryKeys);

  useEffect(() => {
    const smartbanner = document.querySelector(".smartbanner");
    if (smartbanner) {
    }
  }, []);

  return (
    <Layout className={styles.layout}>
      {!!queryKeys.length && (
        <div
          className={styles.spinWrapper}
          style={{
            height: pullDistance,
            transition:
              isRefreshing || pullDistance === 0 ? "height 0.2s" : "none",
          }}
        >
          <Spin
            size="medium"
            className={styles.spin}
            style={{
              opacity: isRefreshing || isReady ? 1 : pullDistance / THRESHOLD,
            }}
          />
        </div>
      )}

      <Layout.Content>{children}</Layout.Content>
      {!withoutToolbar && <NavBar />}
    </Layout>
  );
};
